import { useEffect, useState } from "react";
import SearchSelectBox from "../../../../utils/SearchSelectBox";
import Input from "../../../../Core/Fields/Floating/Input";
import SelectSearch from "../../../../Core/Fields/Floating/SelectSearch";

const Tab2 = ({ read,status , vendor_address, shippingAddr }) => {    
console.log("kdkdkdkdkd",shippingAddr)

  const [editableVendorAddress, setEditableVendorAddress] = useState({});
  useEffect(() => {
    if (vendor_address.currentAddress) {
      setEditableVendorAddress(vendor_address.currentAddress);
    }
  }, [vendor_address.currentAddress]);

  const changeaddress = (name) =>{
    const filterdata = vendor_address.vendor_address_list.filter((item)=>item.name == name);
    vendor_address.setselect_vendor_address(filterdata[0])
  }

  const changeaddress2 = (name) =>{
    console.log("name",name)
    const filterdata = shippingAddr.shippingAddresseslist.filter((item)=>item.name == name);
    shippingAddr.setVendorshipAddress(filterdata[0])
  }
 
  const handleVendorChange = (field, value) => {
    setEditableVendorAddress(prev => ({
      ...prev,
      [field]: value
    }));
  };

  return (
    <div className="row m-0" style={{ padding: "8px", borderRadius: "5px" }}>
      <div className="col-12">
        <div className="tableLabel">
          <p className="mb-1" style={{ color: "#391F84", fontWeight: '500' }}>
            Supplier Address
          </p>
          <div style={{ width: '99.5%', borderBottom: '1px solid #caced3', marginBottom: '15px' }}></div>
        </div>
      </div>
{!read &&(
      <div className="col-md-4 mt-0">
        <div className="mb-3">
          <SearchSelectBox
            list={vendor_address.vendor_address_list}
            setvalue={changeaddress}
            // setvalue={vendor_address.setselect_vendor_address}
            name="Select Supplier Address"
            
          />
        </div>
      </div>
)}
      {["address_line1", "address_line2", "city", "state", "country", "pincode", "phone"].map((field, idx) => (
        <div className="col-md-4 mt-0 mb-2" key={idx}>
        <Input id="orderdatepo" style={{ height: "30px" }} label={field.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase())} className="custom-readonly" readOnly disabled={read} value={editableVendorAddress[field] || ""}  onChange={(e) => handleVendorChange(field, e.target.value)}
 />


        </div>
      ))}

      <div className="col-12 mt-3">
        <div className="tableLabel">
          <p className="mb-1" style={{ color: "#391F84", fontWeight: '500' }}>
            Shipping Address
          </p>
          <div style={{ width: '99.5%', borderBottom: '1px solid #caced3', marginBottom: '15px' }}></div>
        </div>
      </div>

      <div className="col-md-4 mt-0">

                {/* <Input id="orderdatepo" style={{ height: "30px" }} label="Shipping Address" className="custom-readonly" readOnly disabled={read}  value={shippingAddr.currentAddress || ""}   /> */}

       {!read ? (
                  <SelectSearch
            list={shippingAddr?.shippingAddresseslist == null ? [] : shippingAddr?.shippingAddresseslist }
            // setvalue={changeaddress2}
            onChange={(val) => changeaddress2(val)}
            label="Select Shipping Address"
            getOptionLabel={(item) => item.name}
            getOptionValue={(item) => item.name}
            value={shippingAddr?.currentAddress.name}
            // name="Select Shipping Address"
            
          />) : <Input id="orderdatepo" style={{ height: "30px" }} label="Shipping Address" className="custom-readonly" readOnly disabled={read} value={shippingAddr?.currentAddress?.name || ""}   />}


      </div>
    </div>
  );
};

export default Tab2;
